'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _toolbar = require('../../toolbar');

var _toolbar2 = _interopRequireDefault(_toolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PrivacyController = function PrivacyController($document, config) {
  _classCallCheck(this, PrivacyController);

  this.config = config;
  this._svc = {
    $document: $document
  };

  $document.scrollTop(0, 1000);
};

exports.default = angular.module('ifeis.routes.privacy', ['ui.router', 'ifeis.toolbar']).config(function ($stateProvider) {
  $stateProvider.state('privacy', {
    url: '/privacy',
    controller: 'PrivacyController',
    controllerAs: 'ctrl',
    template: require('./tpl.html')
  });
}).controller('PrivacyController', PrivacyController);


//////////////////
// WEBPACK FOOTER
// ./routes/privacy/index.js
// module id = 602
// module chunks = 0